import { combineReducers } from "@reduxjs/toolkit";
import order from "./orderSlice";
import draftOrder from "./draftOrderSlice";
import checkout from "./checkoutSlice";
import groupReturn from "./groupReturnSlice";
import pendingOrderList from "./pendingOrderSlice";
import cancelOrder from "./cancelOrderSlice";
import pickingTicket from "./pickingTicketSlice";
import usOrder from "./usOrderSlice";
import ieOrder from "./ieOrderSlice";
import restockReport from "./restockReportSlice";
import returnOrder from "./returnOrderSlice";
import tracking from "./trackingSlice";
import frasersPlus from "./frasersPlusSlice";

const orderReducer = combineReducers({
  order,
  draftOrder,
  checkout,
  groupReturn,
  pendingOrderList,
  cancelOrder,
  pickingTicket,
  usOrder,
  ieOrder,
  restockReport,
  returnOrder,
  tracking,
  frasersPlus,
});

export default orderReducer;
